import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { ReconciliationRepository } from "../domain/ReconciliationRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { Reconciliation } from "../domain/Reconciliation";
import { ReconciliationWithReference } from "~/context/Reconciliations/domain/ReconciliationWithReference";

import { ReconciliationReferenceIdAndType } from "~/context/Shared/domain/save/ReconciliationReferenceIdAndType";
import { ReconciliationWithReferenceFull } from "../domain/ReconciliationWithReferenceFull";
import { ReconciliationReferenceIdAndTypeWithRate } from "~/context/Shared/domain/save/ReconciliationReferenceIdAndTypeWithRate";

export function createApiReconciliationRepository(): ReconciliationRepository {
  return new ApiReconciliationRepository();
}

export class ApiReconciliationRepository extends APIRepository implements ReconciliationRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  deleteReferences(reconciliationReferenceIdAndType: ReconciliationReferenceIdAndType): Promise<void> {
    return this.doPostNew<ReconciliationReferenceIdAndType>("/api/compose/reconciliation/references/general/remove", null, reconciliationReferenceIdAndType);
  }

  saveReconciliationAndReferences(reconciliationAndReferencesObject: ReconciliationReferenceIdAndType): Promise<void> {
    console.log("call api /compose/reconciliation/references/general:" + JSON.stringify(reconciliationAndReferencesObject));
    return this.doPostNew<ReconciliationReferenceIdAndType>("/api/compose/reconciliation/references/general", null, reconciliationAndReferencesObject);
  }

  saveReconciliationAndReferencesWithRate(reconciliationAndReferencesObject: ReconciliationReferenceIdAndTypeWithRate): Promise<void> {
    console.log("call api /compose/reconciliation/references/generalWithRate:" + JSON.stringify(reconciliationAndReferencesObject));
    return this.doPostNew<ReconciliationReferenceIdAndTypeWithRate>("/api/compose/reconciliation/references/generalWithRate", null, reconciliationAndReferencesObject);
  }


  async getReferencesFullByReferenceObjectAndType(companyId: string, objectId: string, type: string): Promise<ReconciliationWithReferenceFull> {
    const response = await this.doGet<ReconciliationWithReferenceFull>("/api/compose/reconciliation/full/references/company/"+ companyId.toString() +"/type/" + type.toString() + "/object/" + objectId.toString());
    console.log("getReferencesFullByReferenceObjectAndType companyId:" + companyId + "objectId:" + objectId + " - type:" + type);
    console.log("getReferencesFullByReferenceObjectAndType response:" + JSON.stringify(response));
    return response;
  }



  getReconciliation(reconciliationUid: string): Promise<Reconciliation | undefined> {
    return this.doGet<Reconciliation>("/api/reconciliations/" + reconciliationUid.toString());
  }



  async getReferencesByReferenceObjectAndType(companyId: string, objectId: string, type: string): Promise<ReconciliationWithReference> {
    const response = await this.doGet<ReconciliationWithReference>("/api/compose/reconciliation/references/company/"+ companyId.toString() +"/type/" + type.toString() + "/object/" + objectId.toString());
    console.log("getReferencesByReferenceObjectAndType companyId:" + companyId + "objectId:" + objectId + " - type:" + type);
    console.log("getReferencesByReferenceObjectAndType response:" + JSON.stringify(response));
    return response;
  }

  addReconciliation(_reconciliation: Reconciliation): Promise<void> {
    throw new Error("Method not implemented.");
  }
  getReconciliationsByTypeAndUid(_reconciliationTypeId: string, _reconciliationPrincipalUid: string): Promise<Reconciliation[] | undefined> {
    throw new Error("Method not implemented.");
  }
  getReconciliationsByTypeAndCompanyId(_reconciliationTypeId: string, _reconciliationCompanyId: string): Promise<Reconciliation[] | undefined> {
    throw new Error("Method not implemented.");
  }
  getReconciliationsByCompanyId(_reconciliationCompanyId: string): Promise<Reconciliation[] | undefined> {
    throw new Error("Method not implemented.");
  }


}
